'use strict';

module.exports = {
  scenario: 'scenario',
  workpackage: 'workpackage',
  cannGroup: 'cann-group',
};
